export enum LinkTypeEnum {
  External = 'link-external',
  Internal = 'link-content',
  Module = 'internal-module',
  Dropdown = 'dropdown',
}
